var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMealsComponnatIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.08301 5.125C8.56873 5.12515 9.88988 6.14201 10.8467 7.64453C11.8011 9.14334 12.374 11.0997 12.374 12.917C12.374 14.7288 11.7786 16.047 10.8291 16.9131C9.8773 17.781 8.55564 18.2079 7.08301 18.208C5.61023 18.208 4.28872 17.7811 3.33691 16.9131C2.38716 16.047 1.79109 14.729 1.79102 12.917C1.79102 11.0997 2.3649 9.14335 3.31934 7.64453C4.27621 6.14206 5.59728 5.125 7.08301 5.125Z",
    stroke: "#888888",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1172 2.93062C12.576 1.90889 14.1852 1.47472 15.5576 2.04292C16.9304 2.61151 17.7623 4.05703 18.0713 5.81148C18.3795 7.56137 18.1602 9.58769 17.4648 11.2666C16.8779 12.6836 16.0309 13.6078 15.0518 14.124C15.0986 13.7316 15.124 13.3287 15.124 12.916C15.124 10.5776 14.4026 8.10889 13.166 6.16695C12.5171 5.14793 11.6254 4.13286 10.499 3.40816C10.7012 3.23813 10.9074 3.07758 11.1172 2.93062Z",
    stroke: "#888888",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMealsComponnatIcon);
export default __webpack_public_path__ + "static/media/meals-componnat-icon.afdbdec1c93008d450b9176396655097.svg";
export { ForwardRef as ReactComponent };